import { SectionDataWeb } from '@nucleus/types/web';
import { useContext } from 'react';
import { SectionContext } from '../components/sections/SectionContext';

export const useSection = <T extends SectionDataWeb = SectionDataWeb>(): T => {
  const { section } = useContext(SectionContext);

  return section as T;
};
